import React, { useEffect, useState } from 'react';
import { Button, Card, InputNumber, Space, TimePicker, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useOptimisticBookingState } from '@core/hooks';
import { BookingSetting } from '@core/models';
import dayjs from 'dayjs';
import moment from 'moment';
import { MIDDLE_STYLE } from '@constants/responsive';
import { bookingApiService } from '@services/service-register';
import { useAppDispatch } from '@core/configureStore';
import { fetchBookingSetting } from '@core/features/booking/thunks/fetchBookingSetting.thunk';

type Props = {};

const BookingSettingTab = (props: Props) => {
  const dispatch = useAppDispatch();
  const { bookingSetting } = useOptimisticBookingState();
  const [currentBookingSetting, setCurrentBookingSetting] = useState<BookingSetting | undefined>(
    undefined
  );

  const handleUpdateBookingSetting = async () => {
    if (currentBookingSetting) await bookingApiService.updateBookingSetting(currentBookingSetting);
    await dispatch(fetchBookingSetting());
  };

  const handleInputChange = (updatedBookingSetting: Partial<BookingSetting>) => {
    setCurrentBookingSetting({
      ...(currentBookingSetting || bookingSetting),
      ...updatedBookingSetting,
    });
  };

  useEffect(() => {
    setCurrentBookingSetting(bookingSetting);
  }, [bookingSetting]);
  return (
    <div style={{ ...MIDDLE_STYLE }}>
      <Card
        hoverable
        style={{ height: '100%', padding: 0, maxWidth: 700, width: '100%', borderRadius: 5 }}
        className="tablespace">
        <div>
          <Space size={10} direction="vertical" style={{ width: '100%' }}>
            <Space
              style={{
                justifyContent: 'space-between',
                width: '100%',
                flexWrap: 'wrap',
              }}>
              <Typography.Text strong>Max number of people</Typography.Text>
              <InputNumber
                value={currentBookingSetting?.max_number_of_people}
                onChange={value =>
                  setCurrentBookingSetting({
                    ...bookingSetting,
                    max_number_of_people: value || 0,
                  })
                }
                placeholder="Max number of people"></InputNumber>
            </Space>
            <Space
              style={{
                justifyContent: 'space-between',
                width: '100%',
                flexWrap: 'wrap',
              }}>
              <Typography.Text strong>Opening hours</Typography.Text>
              <Space>
                <TimePicker
                  use12Hours={false}
                  size={'large'}
                  style={{ width: '100%' }}
                  format="h A"
                  value={dayjs.unix(
                    moment({
                      hours: currentBookingSetting?.open_hour,
                    }).unix()
                  )}
                  showNow={true}
                  showMinute={false}
                  showSecond={false}
                  onChange={value => {
                    if (!value) return;
                    handleInputChange({
                      open_hour: value.hour(),
                    });
                  }}
                />
                <TimePicker
                  use12Hours={false}
                  size={'large'}
                  style={{ width: '100%' }}
                  format="h A"
                  value={dayjs.unix(
                    moment({
                      hours: currentBookingSetting?.closed_hour,
                    }).unix()
                  )}
                  showNow={true}
                  showMinute={false}
                  showSecond={false}
                  onChange={value => {
                    if (!value) return;
                    handleInputChange({
                      closed_hour: value.hour(),
                    });
                  }}
                />
              </Space>
            </Space>
          </Space>
          {(bookingSetting.open_hour !== currentBookingSetting?.open_hour ||
            bookingSetting.closed_hour !== currentBookingSetting.closed_hour ||
            bookingSetting.max_number_of_people !== currentBookingSetting.max_number_of_people) && (
            <Button
              type="primary"
              className="success-btn"
              onClick={handleUpdateBookingSetting}
              style={{ float: 'right', marginTop: 20 }}>
              <SaveOutlined /> Save changes
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default BookingSettingTab;
